import { Edit, Trash } from "react-feather";

export const signatoriesColumns = (onEdit, onDelete) => [
    {
      name: 'Id Firmante',
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: 'Nombre',
      selector: (row) => ( `${row.firstName  } ${  row.lastName}` ),
      sortable: true,
    },
    {
      name: 'Documento',
      selector: (row) => row.documentClient,
      sortable: true,
    },
    {
      name: 'Tipo documento',
      selector: (row) => row.identificationTypeId,
      sortable: true,
    },
    {
      name: 'Teléfono',
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: 'Acciones',
      center: true,
      allowOverflow: true,
      cell: (row) => (
        <div className='d-flex'>
          <div className='cursor-pointer text-primary'>
            <Edit onClick={() => onEdit(row)} size={20} />
          </div>
          <div className='ps-1 cursor-pointer'>
              <Trash size={20} onClick={() => onDelete(row.id)} />
          </div>
        </div>
      ),
    },
  ];